module.exports = __webpack_public_path__ + "img/LOGOTIPO_VERSION_1_OPENGES.c99a995d.svg";